import styled, { css } from 'styled-components';

import { ModalContentText } from 'src/app/components/lib/modal';

export const SIDEBAR_WIDTH = 424;

export const HEADER_FOOTER_HEIGHT = 64;

export const DrawerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: ${HEADER_FOOTER_HEIGHT}px 1fr;
`;

export const NavigationContainer = styled.div<{ $isHeader?: boolean; $singleButton?: boolean }>`
  display: flex;
  flex-direction: ${({ $singleButton }) => ($singleButton ? 'row-reverse' : 'row')};
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sizes-60);
  background: var(--color-brand-primary-white);
  ${({ $isHeader }) =>
    $isHeader &&
    css`
      border-bottom: 1px solid var(--color-gray-20);
    `}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: var(--sizes-20);
`;

export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Title = styled.h2<{ $titleFontSize?: string; $titleMinWidth?: string }>`
  color: var(--color-grayscale-black);
  font: ${({ $titleFontSize }) => $titleFontSize ?? 'var(--font-headings-heading-2)'};
  margin: 0;
  min-width: ${({ $titleMinWidth }) => $titleMinWidth ?? 'auto'};
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--sizes-40);
`;

export const Step = styled.div<{ $isClickable: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font: var(--font-small-13pt-semibold);
  color: var(--color-grayscale-black);
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      cursor: pointer;
      color: var(--color-brand-secondary-sapphire);
    `}
`;

export const StepTitle = styled.span<{ $disabled: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: var(--color-gray-70);
    `}
`;

const InactiveStepCircleStyles = css`
  background-color: var(--color-grayscale-white);
  color: var(--color-grayscale-black);
  border: 1px solid var(--color-gray-30);
`;

const ActiveStepCircleStyles = css`
  background-color: var(--color-grayscale-black);
  color: var(--color-grayscale-white);
  border: none;
`;

const CompletedStepCircleStyles = css`
  background-color: var(--color-green-50);
  color: var(--color-grayscale-white);
  border: none;
`;

const DisabledStepCircleStyles = css`
  background-color: var(--color-gray-60);
  color: var(--color-grayscale-white);
  border: none;
`;

export const Circle = styled.span<{ $isActive: boolean; $isComplete: boolean; $isDisabled: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  font: var(--font-small-13pt-semibold);
  line-height: 13px;
  ${({ $isActive, $isComplete }) => !$isActive && !$isComplete && InactiveStepCircleStyles}
  ${({ $isActive }) => $isActive && ActiveStepCircleStyles}
  ${({ $isComplete }) => $isComplete && CompletedStepCircleStyles}
  ${({ $isDisabled }) => $isDisabled && DisabledStepCircleStyles}
`;

export const BodyContainer = styled.div<{ $sidebarVisible: boolean }>`
  display: grid;
  grid-template-columns: ${({ $sidebarVisible }) => ($sidebarVisible ? `1fr ${SIDEBAR_WIDTH}px` : '100%')};
  height: 100%;
  grid-column-gap: 0;
  overflow: hidden;
`;

export const LeftPanel = styled.div<{ $navigationVisible: boolean }>`
  display: grid;
  grid-template-rows: ${({ $navigationVisible }) => ($navigationVisible ? `1fr ${HEADER_FOOTER_HEIGHT}px` : '100%')};
  overflow: hidden;
`;

export const MainBodyContainer = styled.div<{ $fullWidthAndHeight: boolean }>`
  padding: ${({ $fullWidthAndHeight }) => ($fullWidthAndHeight ? '0' : 'var(--sizes-80) 84px')};
  background: var(--color-gray-10);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
`;

export const SidebarContainer = styled.div`
  background: var(--color-brand-primary-white);
  border-left: 1px solid var(--color-gray-20);
  overflow: auto;
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const CenteredModalContentText = styled(ModalContentText)`
  text-align: center;
`;
